<div class="panel__header">
  <div>
    <h2>{{ 'admin.discordBot.title' | adminTranslate }}</h2>
    <p class="panel__lede">{{ 'admin.discordBot.lede' | adminTranslate }}</p>
  </div>
  <div class="section-block__actions">
    <ui-button variant="primary" size="sm" (click)="save()" [disabled]="saving || loading">
      {{ saving ? ('admin.common.saving' | adminTranslate) : ('admin.common.save' | adminTranslate) }}
    </ui-button>
    <ui-button variant="secondary" size="sm" (click)="resetDraft()" [disabled]="saving || loading">
      {{ 'admin.common.reset' | adminTranslate }}
    </ui-button>
  </div>
</div>

@if (loading) {
  <p class="empty">{{ 'admin.discordBot.loading' | adminTranslate }}</p>
} @else if (settings; as currentSettings) {
  <div class="discord-bot-layout">
    <section class="editor-block">
      <div class="form-grid">
        <label class="form-field">
          <span>{{ 'admin.discordBot.fields.username' | adminTranslate }}</span>
          <ui-input [(ngModel)]="username" [placeholder]="'admin.discordBot.placeholders.username' | adminTranslate"></ui-input>
        </label>

        <label class="form-field form-field--wide">
          <span>{{ 'admin.discordBot.fields.avatarUrl' | adminTranslate }}</span>
          <ui-input [(ngModel)]="avatarUrl" [placeholder]="'admin.discordBot.placeholders.avatarUrl' | adminTranslate"></ui-input>
        </label>

        <label class="form-field form-field--wide">
          <span>{{ 'admin.discordBot.fields.description' | adminTranslate }}</span>
          <textarea [(ngModel)]="applicationDescription" rows="5" [placeholder]="'admin.discordBot.placeholders.description' | adminTranslate"></textarea>
        </label>
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.discordBot.release.title' | adminTranslate }}</h3>
        </div>
        <div class="release-setup">
          <div class="release-setup__card">
            <h4>{{ 'admin.discordBot.release.accountTitle' | adminTranslate }}</h4>
            <p class="notice">{{ 'admin.discordBot.release.accountNotice' | adminTranslate }}</p>
            <div class="section-block__actions section-block__actions--start">
              <ui-button variant="secondary" size="sm" (click)="connectDiscord()" [disabled]="linkingDiscord || loading">
                {{ linkingDiscord ? ('admin.discordBot.release.connecting' | adminTranslate) : ('admin.discordBot.release.connect' | adminTranslate) }}
              </ui-button>
            </div>
          </div>

          <div class="release-setup__card">
            <h4>{{ 'admin.discordBot.release.serverTitle' | adminTranslate }}</h4>
            <p class="notice">{{ 'admin.discordBot.release.serverNotice' | adminTranslate }}</p>
            @if (loadingDiscordSources) {
              <p class="empty">{{ 'admin.discordBot.release.loadingSources' | adminTranslate }}</p>
            } @else if (unlinkedGuilds().length) {
              <div class="guild-list">
                @for (guild of unlinkedGuilds(); track guild.id) {
                  <button type="button" class="guild-pill" (click)="linkGuild(guild)">
                    <span>{{ guild.name }}</span>
                    <strong>{{ 'admin.discordBot.release.useServer' | adminTranslate }}</strong>
                  </button>
                }
              </div>
            } @else {
              <p class="empty">{{ 'admin.discordBot.release.noAdditionalServers' | adminTranslate }}</p>
            }
          </div>
        </div>
        <div class="form-grid">
          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releaseAnnouncementsGuildId' | adminTranslate }}</span>
            <ui-select [(ngModel)]="releaseAnnouncementsGuildId" (ngModelChange)="onReleaseGuildChange($event)">
              <option value="">{{ 'admin.discordBot.release.selectServer' | adminTranslate }}</option>
              @for (option of guildSelectionOptions(); track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </ui-select>
          </label>

          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releaseAnnouncementsChannelId' | adminTranslate }}</span>
            <ui-select [(ngModel)]="releaseAnnouncementsChannelId" [disabled]="!releaseAnnouncementsGuildId || loadingChannels">
              <option value="">{{ loadingChannels ? ('admin.discordBot.release.loadingChannels' | adminTranslate) : ('admin.discordBot.release.selectChannel' | adminTranslate) }}</option>
              @for (option of channelSelectionOptions(); track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </ui-select>
          </label>

          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releaseTagName' | adminTranslate }}</span>
            <ui-input [(ngModel)]="releaseTagName" [placeholder]="'admin.discordBot.placeholders.releaseTagName' | adminTranslate"></ui-input>
          </label>

          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releaseName' | adminTranslate }}</span>
            <ui-input [(ngModel)]="releaseName" [placeholder]="'admin.discordBot.placeholders.releaseName' | adminTranslate"></ui-input>
          </label>

          <label class="form-field form-field--wide">
            <span>{{ 'admin.discordBot.fields.releaseUrl' | adminTranslate }}</span>
            <ui-input [(ngModel)]="releaseUrl" [placeholder]="'admin.discordBot.placeholders.releaseUrl' | adminTranslate"></ui-input>
          </label>

          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releasePublishedAt' | adminTranslate }}</span>
            <ui-input [(ngModel)]="releasePublishedAt" [placeholder]="'admin.discordBot.placeholders.releasePublishedAt' | adminTranslate"></ui-input>
          </label>

          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.releaseCommitSha' | adminTranslate }}</span>
            <ui-input [(ngModel)]="releaseCommitSha" [placeholder]="'admin.discordBot.placeholders.releaseCommitSha' | adminTranslate"></ui-input>
          </label>

          <label class="form-field form-field--wide">
            <span>{{ 'admin.discordBot.fields.releaseDescription' | adminTranslate }}</span>
            <textarea [(ngModel)]="releaseDescription" rows="6" [placeholder]="'admin.discordBot.placeholders.releaseDescription' | adminTranslate"></textarea>
          </label>
        </div>
        <p class="notice">
          {{ 'admin.discordBot.release.notice' | adminTranslate }}
        </p>
        <div class="section-block__actions">
          <ui-button variant="secondary" size="sm" (click)="publishRelease()" [disabled]="publishingRelease || loading">
            {{ publishingRelease ? ('admin.discordBot.release.publishing' | adminTranslate) : ('admin.discordBot.release.publish' | adminTranslate) }}
          </ui-button>
        </div>
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.discordBot.activity.title' | adminTranslate }}</h3>
        </div>
        <div class="form-grid">
          <label class="form-field">
            <span>{{ 'admin.discordBot.fields.activityType' | adminTranslate }}</span>
            <ui-select [(ngModel)]="activityType">
              @for (option of activityTypes; track option.value) {
                <option [value]="option.value">{{ option.labelKey | adminTranslate }}</option>
              }
            </ui-select>
          </label>

          <label class="form-field form-field--wide">
            <span>{{ 'admin.discordBot.fields.activityText' | adminTranslate }}</span>
            <ui-input [(ngModel)]="activityText" [placeholder]="'admin.discordBot.placeholders.activityText' | adminTranslate"></ui-input>
          </label>
        </div>
        <p class="notice">
          {{ 'admin.discordBot.activity.notice' | adminTranslate }}
        </p>
      </div>

      <div class="section-block">
        <div class="section-block__header">
          <h3>{{ 'admin.discordBot.auditReason.title' | adminTranslate }}</h3>
        </div>
        <textarea [(ngModel)]="reason" rows="3" [placeholder]="'admin.discordBot.auditReason.placeholder' | adminTranslate"></textarea>
      </div>
    </section>

    <aside class="preview-block">
      <div class="preview-card">
        <div class="preview-card__top">
          <div class="preview-avatar">
            @if (avatarUrl || currentSettings.avatarUrl) {
              <img [src]="avatarUrl || currentSettings.avatarUrl || ''" [alt]="username || currentSettings.username || ('admin.discordBot.title' | adminTranslate)" />
            } @else {
              <span>{{ (username || currentSettings.username || 'F').charAt(0) | uppercase }}</span>
            }
          </div>
          <div class="preview-meta">
            <strong>{{ username || currentSettings.username || currentSettings.applicationName || ('admin.discordBot.placeholders.username' | adminTranslate) }}</strong>
            <span>{{ currentSettings.applicationName || ('admin.users.providers.DISCORD' | adminTranslate) }}</span>
          </div>
        </div>

        <p class="preview-description">
          {{ applicationDescription || currentSettings.applicationDescription || ('admin.common.notProvided' | adminTranslate) }}
        </p>

        <div class="preview-kpis">
          <div class="preview-kpi">
            <span>{{ 'admin.discordBot.preview.sync' | adminTranslate }}</span>
            <strong>{{ currentSettings.botConfigured ? ('admin.discordBot.preview.connected' | adminTranslate) : ('admin.discordBot.preview.notConfigured' | adminTranslate) }}</strong>
          </div>
          <div class="preview-kpi">
            <span>{{ 'admin.discordBot.preview.activity' | adminTranslate }}</span>
            <strong>{{ previewActivity() }}</strong>
          </div>
          <div class="preview-kpi">
            <span>{{ 'admin.discordBot.preview.releaseServer' | adminTranslate }}</span>
            <strong>{{ selectedGuildLabel(currentSettings.releaseAnnouncementsGuildId) || ('admin.common.notProvided' | adminTranslate) }}</strong>
          </div>
          <div class="preview-kpi">
            <span>{{ 'admin.discordBot.preview.releaseChannel' | adminTranslate }}</span>
            <strong>{{ selectedChannelLabel(currentSettings.releaseAnnouncementsChannelId) || releaseAnnouncementsChannelId || currentSettings.releaseAnnouncementsChannelId || ('admin.common.notProvided' | adminTranslate) }}</strong>
          </div>
          <div class="preview-kpi">
            <span>{{ 'admin.discordBot.preview.lastUpdate' | adminTranslate }}</span>
            <strong>{{ currentSettings.updatedAt ? (currentSettings.updatedAt | date:'dd/MM/yyyy HH:mm') : ('admin.common.never' | adminTranslate) }}</strong>
          </div>
        </div>
      </div>
    </aside>
  </div>
}
